import React from 'react';
import { IconButton, SvgIcon } from '@mui/material';
import styles from './AppTeamsButton.module.scss';
import AppTeamsIcon from './AppTeamsIcon';

interface AppTeamsButtonProps {
  teamsUrl: string;
}

const AppTeamsButton: React.FC<AppTeamsButtonProps> = (props) => {
  const { teamsUrl } = props;

  return (
    <IconButton
      className={styles.Button}
      onClick={(event) => event.stopPropagation()}
      size="large"
    >
      <a
        href={teamsUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open Teams"
      >
        <SvgIcon fontSize="small">
          <AppTeamsIcon />
        </SvgIcon>
      </a>
    </IconButton>
  );
};

export default AppTeamsButton;
